/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, func, shape, string,
    number, objectOf, bool, arrayOf,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import GraphqlPortalLoader from '../../../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';
import MiniCart from '../../../../../../components/Checkout/containers/CheckoutFood/components/Partials/MiniCart/MiniCart';
import { getLoaderStatus } from '../../../../../../../state/ducks/Common/Common-Selectors';
// import Spinner from '../../../../assets/svg/Spinner';
import AccountLeftMenu from '../../../../common/Desktop/AccountLeftMenu';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import DesktopOccasionDropdown from '../DesktopOccasionDropdown';
import DesktopRecipientDetails from '../Modal/DesktopRecipientDetails';
import DesktopPagination from '../DesktopPagination';
import configENV from '../../../../config';
import { isEmpty } from '../../../../utils/object';
import { getCartAttributeByNameAndReturnValue } from '../../../../../../helpers/page/pageHelpers';

const { PERSIST_KEY } = configENV;

const styles = (theme) => ({
    container: {
        width: '100%',
        maxWidth: '1440px',
        margin: 'auto',

        '& .titleWrapper': {
            position: 'relative',
            width: 900,
            marginBottom: 24,
            '& .titleText': {
                fontSize: 24,
                fontWeight: 500,
                paddingRight: 24,
            },
        },

        '& .giftingWrapper': {
            width: '100%',
            maxWidth: 900,
            marginBottom: 24,
        },
        '& .selectTwoProducts': {
            clear: 'both',
            background: theme.palette.secondary?.main,
            color: theme.palette.white,
            padding: '5px',
            margin: '0px 2px 11px 25px',
            fontSize: '14px',
            width: '73%',
            textAlign: 'center',
            whiteSpace: 'normal',
        },

        '& .tooltipWrapper': {
            position: 'relative',
            display: 'inline-block',
            '& .tooltipIcon': {
                position: 'absolute',
                top: '-18px',
                left: '-20px',
                width: 24,
                height: 24,
                backgroundImage: 'url("data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTExIDE4aDJ2LTJoLTJ2MnptMS0xNkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptMCAxOGMtNC40MSAwLTgtMy41OS04LThzMy41OS04IDgtOCA4IDMuNTkgOCA4LTMuNTkgOC04IDh6bTAtMTRjLTIuMjEgMC00IDEuNzktNCA0aDJjMC0xLjEuOS0yIDItMnMyIC45IDIgMmMwIDItMyAxLjc1LTMgNWgyYzAtMi4yNSAzLTIuNSAzLTUgMC0yLjIxLTEuNzktNC00LTR6Ii8+PC9zdmc+")',
                backgroundRepeat: 'no-repeat',
                opacity: 0.5,
                '&:hover': {
                    '& + .tooltipContent': {
                        display: 'inline-block',
                        zIndex: 1,
                    },
                },
            },
            '& .tooltipContent': {
                top: '-30px',
                left: '6px',
                display: 'none',
                position: 'absolute',
                width: '230px',
                padding: '6px',
                color: '#fff',
                backgroundColor: theme.palette.cta1,
                fontSize: 12,
                borderRadius: 4,
                '&.whiteBackground': {
                    borderRadius: 0,
                    fontSize: 14,
                    padding: 0,
                    backgroundColor: '#fff',
                    color: '#000',
                    'box-shadow': '5px 5px 10px 0px rgba(0,0,0,0.5)',
                },
            },
        },

        '& .holidayGifting': {
            width: '350px !important',
            '& .howTo': {
                position: 'relative',
                padding: 12,
                borderBottom: '1px solid #C3D6C7', // TODO
                '& .giftIcon': {
                    position: 'relative',
                    top: 5,
                    marginRight: 12,
                    color: '#657668',
                    width: 24,
                    height: 24,
                    backgroundImage: 'url("data:image/svg+xml;base64, PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIAogcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pbllNaW4iIHg9IjB4IiB5PSIwcHgiCmVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMwIDMwIgp2aWV3Qm94PSIwIDAgMzAgMzAiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnIGZpbGw9IiM2NTc2NjgiIHRyYW5zZm9ybT0ic2NhbGUoMC4wMykiPjxwYXRoIGlkPSJnaWZ0SWNvbkhEIiBkPSJNNzUxLjMsMzA4LjNjMTcuNi0xMi41LDM0LjQtMjYuNCw0OS44LTQxLjhjMzIuMy0zMi4zLDU0LTcyLjEsNjAuOS0xMTIuMWM3LjYtNDMuOC0zLjYtODQuNC0zMC42LTExMS41Yy0yMS42LTIxLjYtNTAuOC0zMy04NC42LTMzYy00OC4xLDAtOTguNywyMy4xLTEzOC45LDYzLjNDNTQzLjUsMTM3LjcsNTA2LDIyNi41LDQ4NS44LDI4OS45Yy0xNS02My43LTQ0LjctMTQ5LjctMTAyLjctMjA3LjdjLTMxLjEtMzEuMS03MC44LTQ3LTEwOC4zLTQ3Yy0zMC43LDAtNTkuOCwxMC43LTgxLjYsMzIuNGMtNDguNCw0OC40LTQxLjksMTMzLjQsMTQuNiwxODkuOWMyMC4xLDIwLjEsNDMuNywzNi45LDY4LjUsNTAuOEg2Ni4ydjI0Ny45aDYyVjk5MGg3NDMuN1Y1NTYuMmg2MlYzMDguM0g3NTEuM0w3NTEuMywzMDguM3ogTTY1Ny4yLDEyMi42YzI2LjgtMjYuOCw2MC4zLTQyLjksODkuNi00Mi45YzEwLjQsMCwyNC45LDIuMiwzNS4zLDEyLjZjMjUuMiwyNS4yLDExLjEsODMuNi0zMC4zLDEyNC45Yy00Mi42LDQyLjYtOTkuOCw3MS44LTE0OS41LDkxLjFoLTQ5LjFDNTcxLjIsMjUyLjYsNjAzLjYsMTc2LjIsNjU3LjIsMTIyLjZMNjU3LjIsMTIyLjZ6IE0yMzAuNywxNTQuMmMtMC43LTguOCwwLTI1LjQsMTEuOC0zNy4zYzkuOS05LjksMjMtMTIsMzIuMy0xMmwwLDBjMjAuNiwwLDQyLjEsOS43LDU5LDI2LjZjMzIuOCwzMi44LDU5LjgsODUsNzguMSwxNTAuOWMwLjUsMS44LDEsMy42LDEuNCw1LjNjLTEuOC0wLjUtMy41LTEtNS4zLTEuNEMzNDIuMSwyNjguMSwyOTAsMjQxLDI1Ny4yLDIwOC4yQzI0MS44LDE5Mi45LDIzMi4yLDE3My4yLDIzMC43LDE1NC4yTDIzMC43LDE1NC4yeiBNNDM4LDkyOEgxOTAuMVY1MjUuMkg0MzhWOTI4eiBNNDM4LDQ5NC4ySDEyOC4yVjM3MC4zSDQzOFY0OTQuMnogTTgwOS45LDkyOEg1NjJWNTI1LjJoMjQ3LjlWOTI4eiBNODcxLjgsNDk0LjJINTYyVjM3MC4zaDMwOS45VjQ5NC4yeiIvPjwvZz48L3N2Zz4=")',
                    backgroundRepeat: 'no-repeat',
                    display: 'inline-block',
                },
            },
            '& .stepOrders': {
                position: 'relative',
                padding: 12,
                '& .step': {
                    marginBottom: 12,
                    '& > span': {
                        position: 'relative',
                        top: 2,
                        fontWeight: 400,
                        fontStyle: 'italic',
                        fontSize: 20,
                        color: '#fff',
                        backgroundColor: '#657668',
                        padding: '2px 6px',
                        display: 'inline-block',
                        borderRadius: '50%',
                        marginRight: 6,
                        width: '25px',
                        height: '25px',
                    },
                },
            },
        },

        '& .buttonHD.regularBtn': {
            width: '150px !important',
            textTransform: 'inherit',
            border: `1px solid ${theme.palette.primaryButton}`,
            boxShadow: 'none',
            float: 'none',
            '&:hover': {
                border: `1px solid ${theme.palette.primaryButton}`,
                backgroundColor: theme.palette.primaryButton,
            },
        },

        '& .occasionDropdown': {
            float: 'right',
            width: 'auto',
        },

        '& .cardLayout': {
            width: '100%',
            maxWidth: 900, // 12 * 75
            marginBottom: 36, // 12 * 3
            position: 'relative',
            'box-shadow': '0px 0px 10px 0px rgba(0,0,0,0.5)',
            '& .spinner': {
                display: 'none',
                zIndex: 2,
            },
            '&.waiting': {
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    backgroundColor: '#fff',
                    opacity: 0.85,
                    width: '100%',
                    height: '100%',
                },
                '& .spinner': {
                    display: 'block',
                },
            },
            '& .cardHeader': {
                display: 'flex',
                justifyContent: 'flex-start',
                '& .recipientInfo': {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: theme.palette.cta1,
                    color: '#fff',
                    borderBottom: `1px solid ${theme.palette.cta1}`,
                    padding: 12,
                    '& > div': {
                        fontSize: 16,
                        paddingBottom: 12,
                        '&:last-child': {
                            paddingBottom: 0,
                        },
                    },
                },
                '& .actionBlock': {
                    display: 'flex',
                    justifyContent: 'flex-start',
                    borderBottom: '1px solid #657668', // TODO
                    '& button': {
                        background: 'none',
                        color: '#657668', // TODO
                        border: 'none',
                        margin: 0,
                        width: 84, // 12 * 7
                        padding: '12px !important',
                        cursor: 'pointer',
                        borderRight: '1px solid #657668', // TODO
                        minWidth: 'auto',
                        borderRadius: '0 !important',
                        '&.icon-top': {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            '& span': {
                                display: 'block',
                            },
                        },
                        '&:hover': {
                            border: 0,
                            backgroundColor: '#657668', // TODO
                            color: '#fff',
                        },
                        '&:last-child': {
                            borderRight: 'none',
                        },
                    },
                },
            },
            '& .collapsable': {
                display: 'block',
                '&.collapse': {
                    display: 'none',
                },
            },
            '& .cardContent': {
                '& .deliveryInfo': {
                    margin: 24,
                    '& .productSent': {
                        color: theme.palette.primaryButton,
                    },
                },
                '& .closestMatchTitle': {
                    fontWeight: '700',
                    fontSize: '18px',
                    margin: '10px 0px -18px 1px',
                },
                '& .closestMatchContainer': {
                    borderTop: '1px solid',
                    width: '85%',
                    margin: '0px 0px -23px 67px',
                },
                '& .otherRecom': {
                    margin: '0px 0px 1px 199px',
                    fontWeight: '700',
                    fontSize: '18px',
                },
                '& .carouselWrapper': {
                    padding: '0 60px',
                    margin: '24px 0',
                    overflowX: 'hidden',
                    '& .slick-slider': {
                        display: 'inline-grid',
                        'align-items': 'center',
                        '& .slick-arrow': {
                            position: 'absolute', //
                            margin: 12,
                            padding: 0,
                            display: 'block',
                            background: 'none',
                            // border: 'none',
                            border: '1px solid',
                            color: 'transparent',
                            width: '32px',
                            height: '32px',
                            minWidth: 'auto',
                            borderRadius: '50% !important',
                            cursor: 'pointer',
                            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
                            '&:before': {
                                position: 'absolute',
                                top: 3,
                                left: 1,
                                width: '30px',
                                height: '30px',
                                content: 'url("data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDBWMHoiIGZpbGw9Im5vbmUiLz48cGF0aCBkPSJNOC41OSAxNi41OUwxMy4xNyAxMiA4LjU5IDcuNDEgMTAgNmw2IDYtNiA2LTEuNDEtMS40MXoiLz48L3N2Zz4=")',
                                color: '#2f2f2f',
                                borderRadius: '50%',
                            },
                            '&.slick-prev:before': {
                                top: -3,
                                left: -1,
                                transform: 'rotate(-180deg)',
                            },
                            '&.slick-prev': {
                                left: -54,
                            },
                            '&.slick-next': {
                                left: 'unset',
                                right: -54,
                            },
                            '&.slick-disabled:before': {
                                opacity: 0.3,
                            },
                        },
                    },
                    '& .slick-list': {
                        overflowX: 'hidden',
                        height: 'auto !important',
                    },
                    '& .slick-slide': {
                        margin: '6px 0 !important',
                        padding: '0 10px',
                    },
                },
            },
            '& .cardFooter': {
                display: 'flex',
                padding: 24,
                borderTop: `${'1px solid'} ${theme.palette.myAccount.contentGridBorder}`,
                '& .findAnotherGift': {
                    flex: 'none',
                    width: 12 * 22,
                },
                '& .shopTheSiteWrapper': {
                    flex: 1,
                    '& .shop-the-site-button, & .enter-item-number-button': {
                        textDecoration: 'underline',
                        marginRight: 24,
                        fontWeight: 700,
                        cursor: 'pointer',
                    },
                },
            },
        },
    },
});

class DesktopGiftListUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            minicartModalOpen: false,
            isOneProductClick: false,
        };
    }

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
        this.nonCheckProductClick();

        // doing true here minicartModalOpen instead of will recieve props because that case was invoking if any change happens to props values and mini-cart not closing
        const { productAddedToCart, actionRequest } = this.props;
        if (productAddedToCart && actionRequest === 'HANDLE_GIFT_LIST_ADD_TO_CART_REQUEST') {
            this.setState({ minicartModalOpen: true });
        }
    };

    componentDidUpdate(prevProps) {
        const {
            productAddedToCart, productsInCart, actionRequest,
            orderCount, refechGiftListOnPageLoad,
        } = this.props;

        if (
            productAddedToCart && prevProps.productsInCart !== productsInCart
            && actionRequest === 'HANDLE_GIFT_LIST_ADD_TO_CART_REQUEST'
        ) {
            this.setState({ minicartModalOpen: true });
        }

        // use of this function here to update gift list
        // without page reload if item get deleted
        if (prevProps.orderCount > orderCount) {
            refechGiftListOnPageLoad();
        }
    }

    handleMiniCartModalClick = (setModal) => {
        const { minicartModalOpen } = this.state;
        if (minicartModalOpen !== setModal) {
            this.setState({ minicartModalOpen: setModal });
        }
    };

    /**
     * @description Render the mini cart
     */
    getMiniCart = () => {
        const {
            showLoadingMessage,
        } = this.props;
        const { minicartModalOpen } = this.state;
        return (
            <>
                {(showLoadingMessage && minicartModalOpen)
                    && (
                        <GraphqlPortalLoader />
                    )}
                <MiniCart
                    handleMiniCartModalClick={this.handleMiniCartModalClick}
                    minicartModalOpen={minicartModalOpen}
                />
            </>
        );
    }

    checkProductClick = () => {
        this.setState({ isOneProductClick: true });
    }

    nonCheckProductClick = () => {
        this.setState({ isOneProductClick: false });
    }

    render() {
        const {
            classes,
            isReadyState,
            isFetchingModal,
            featureFlags,
            occasionId,
            occasions,
            orderId,
            recipients,
            recipientsByPage,
            productsInCart,
            handleNavigateToPage,
            handleGiftListProceedToCheckout,
            handleGiftListAddNewRecipientClicked,
            handleGiftListEditRecipientClicked,
            handleDesktopRemoveAddressClicked,
        } = this.props;
        const { isOneProductClick } = this.state;

        if (isEmpty(recipients) || isEmpty(occasions) || !occasionId) {
            return null;
        }
        // Check product in cart
        let hasItemInCart = false;
        Object.keys(productsInCart).forEach((key) => {
            const cartItem = productsInCart[key];

            const attributes = cartItem.attributes || [];
            if (getCartAttributeByNameAndReturnValue(attributes, 'giftHistoryOrderItemId')) {
                hasItemInCart = true;
            }
        });

        // if (!isFetchingModal) {
        //     return (
        //         <div className={classes.container}>
        //             <Grid container>
        //                 <AccountLeftMenu
        //                     featureFlags={featureFlags}
        //                 />
        //                 <Grid item xs={10}>
        //                     <div className="spinner gift-list">
        //                         <GraphqlPortalLoader />
        //                     </div>
        //                 </Grid>
        //             </Grid>
        //         </div>
        //     );
        // }

        return (
            <>
                {this.getMiniCart()}
                <div className={classes.container}>
                    <Grid container>
                        <AccountLeftMenu
                            featureFlags={featureFlags}
                        />
                        {!isFetchingModal &&  <GraphqlPortalLoader /> }
                        <Grid item xs={10} style={{ padding: '40px 11px 0 43px' }}>
                            <div className="titleWrapper">
                                <span className="titleText">My Gift List - Holiday Gifting</span>
                                <div className="tooltipWrapper">
                                    <div className="tooltipIcon" />
                                    <div className="tooltipContent whiteBackground holidayGifting">
                                        <div className="howTo">
                                            <span className="giftIcon" /> How to use your Gift List
                                        </div>
                                        <div className="stepOrders">
                                            <div className="step"><span>1</span> Review the gifts you&apos;ve sent</div>
                                            <div className="step"><span>2</span> Choose to send the same gifts or new ones</div>
                                            <div className="step"><span>3</span> Complete your order and leave the rest to us</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="giftingWrapper">
                                <Button
                                    variant="contained"
                                    className="float-none"
                                    onClick={() => handleGiftListAddNewRecipientClicked(occasionId, 'desktop')}
                                >
                                    Add Recipients
                                </Button>
                                <DesktopOccasionDropdown
                                    holidays={occasions}
                                    selected={occasionId}
                                    onChange={(event) => handleNavigateToPage(['/account/gift-list/', event.target.value].join(''), event.target.value, orderId)}
                                />
                            </div>
                            {isOneProductClick
                                ? (
                                    <div className="selectTwoProducts">
                                        <span>Please select at least two products to compare.</span>
                                    </div>
                                ) : null}
                            {isReadyState ? (
                                <>
                                    {recipientsByPage.map((recipient) => (
                                        <DesktopRecipientDetails
                                            key={recipient.id}
                                            recipient={recipient}
                                            onEdit={handleGiftListEditRecipientClicked}
                                            onRemove={handleDesktopRemoveAddressClicked}
                                            checkProductClick={this.checkProductClick}
                                            nonCheckProductClick={this.nonCheckProductClick}
                                        />
                                    ))}

                                    <Button
                                        id="GiftListProceedToCheckoutButton"
                                        variant="contained"
                                        className={
                                            hasItemInCart
                                                ? 'display-none' // hide proceed to checkout for now
                                                : 'display-none'
                                        }
                                        onClick={(event) => handleGiftListProceedToCheckout(
                                            event.target.parentNode,
                                            occasionId,
                                            recipients,
                                        )}
                                    >
                                        Proceed To Checkout
                                    </Button>
                                    <DesktopPagination occasionId={occasionId} />
                                </>
                            ) : (
                                null
                            )}
                        </Grid>
                    </Grid>
                </div>
            </>
        );
    }
}

DesktopGiftListUser.defaultProps = {
    featureFlags: {},
    productsInCart: {},
    productAddedToCart: '',
    showLoadingMessage: false,
    orderCount: 0,
};

DesktopGiftListUser.propTypes = {
    orderCount: number,
    classes: object.isRequired,
    isReadyState: bool.isRequired,
    isFetchingModal: bool.isRequired,
    occasionId: string.isRequired,
    orderId: string.isRequired,
    occasions: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    recipients: objectOf(
        arrayOf(
            shape({
                address: shape({
                    addressId: string,
                    apt: string,
                    city: string,
                    company: string,
                    country: shape({
                        id: string,
                        name: string,
                    }),
                    location: shape({
                        id: number,
                        name: string,
                    }),
                    state: shape({
                        id: string,
                        name: string,
                    }),
                    street: string,
                    zipcode: string,
                }),
                addressId: string,
                firstname: string,
                giftArrived: string,
                id: string,
                isNewRecipient: bool,
                lastname: string,
                occasionId: string,
                orderItemId: string,
                products: arrayOf(
                    shape({
                        content: string,
                        crossedPrice: string,
                        discountPrice: string,
                        id: string,
                        image: string,
                        name: string,
                        parentCatalogEntryId: string,
                        partNumber: string,
                        price: number,
                        seoproductDisplayURL: string,
                        sku: string,
                        status: string,
                    }),
                ),
            }),
        ),
    ).isRequired,
    recipientsByPage: arrayOf(
        shape({
            AddressBookEntryId: string,
            addToCart: string,
            address: shape({
                addressId: string,
                apt: string,
                city: string,
                company: string,
                country: shape({
                    id: string,
                    name: string,
                }),
                location: shape({
                    id: number,
                    name: string,
                }),
                state: shape({
                    id: string,
                    name: string,
                }),
                street: string,
                zipcode: string,
            }),
            addressId: string,
            firstname: string,
            giftArrived: string,
            id: string,
            isNewRecipient: bool,
            lastname: string,
            occasionId: string,
            orderItemId: string,
            products: arrayOf(
                shape({
                    content: string,
                    crossedPrice: string,
                    discountPrice: string,
                    id: string,
                    image: string,
                    name: string,
                    parentCatalogEntryId: string,
                    partNumber: string,
                    price: number,
                    seoproductDisplayURL: string,
                    sku: string,
                    status: string,
                }),
            ),
            type: string,
        }),
    ).isRequired,
    productsInCart: shape({
        addressId: string,
        orderId: string,
        orderItemId: string,
        parentCatentryId: string,
        sku: string,
        productDetail: shape({
            content: string,
            crossedPrice: string,
            discountPrice: string,
            id: string,
            image: string,
            name: string,
            parentCatalogEntryId: string,
            partNumber: string,
            price: number,
            sku: string,
        }),
        xOrderAttrValues: shape({
            giftHistoryOrderItemId: string,
        }),
    }),
    featureFlags: object,
    handleNavigateToPage: func.isRequired,
    handleGiftListProceedToCheckout: func.isRequired,
    handleGiftListAddNewRecipientClicked: func.isRequired,
    handleGiftListEditRecipientClicked: func.isRequired,
    handleDesktopRemoveAddressClicked: func.isRequired,
    productAddedToCart: string,
    showLoadingMessage: bool,
    actionRequest: string.isRequired,
    refechGiftListOnPageLoad: func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    const orderCount = state?.cart?.orderSize || 0;

    return {
        orderCount,
        isReadyState: newState.isReadyState,
        isFetchingModal: newState.isReadyState,
        productsInCart: newState.giftList.productsInCart || {},
        toggleState: newState.toggleState,
        actionType: newState.actionType,
        pageData: newState.pageData,
        orderId: newState.giftList.orderId,
        occasionId: newState.giftList.occasionId,
        occasions: newState.giftList.occasions,
        recipients: newState.giftList.recipients,
        recipientsByPage: newState.giftList.recipientsByPage,
        productAddedToCart: newState.giftList.productAddedToCart,
        showLoadingMessage: getLoaderStatus(state),
        actionRequest: newState.actionType,
    };
};

export const mapDispatchToProps = (dispatch) => ({
    handleGiftListAddNewRecipientClicked: (occasionId, template) => dispatch(EventDispatcher.handleGiftListAddNewRecipientClicked(occasionId, template)),
    handleGiftListProceedToCheckout: (target, occasionId, recipients) => dispatch(EventDispatcher.handleGiftListProceedToCheckout(
        target,
        occasionId,
        recipients,
    )),
    handleGiftListEditRecipientClicked: (recipient, template) => dispatch(EventDispatcher.handleGiftListEditRecipientClicked(recipient, template)),
    handleDesktopRemoveAddressClicked: (recipient, AddressId, addressType) => dispatch(EventDispatcher.handleDesktopRemoveAddressClicked(
        recipient,
        AddressId,
        addressType,
    )),
    handleNavigateToPage: (url, id, orderId) => dispatch(EventDispatcher.handleNavigateToPage(url, id, orderId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(DesktopGiftListUser)));
